type RuntimeConfig = Record<string, string>

let _config: RuntimeConfig | null = null

export async function loadRuntimeConfig(): Promise<void> {
  // In dev mode, skip fetch — import.meta.env / .env.local handles everything
  if (import.meta.env.DEV) return

  // import.meta.url resolves to the bundle file (e.g. /ui/assets/index-[hash].js).
  // One level up from assets/ always lands at the app root, regardless of subdirectory deployment.
  const configUrl = new URL('../config.json', import.meta.url).href
  const res = await fetch(configUrl)
  if (!res.ok) throw new Error(`Failed to load runtime config: HTTP ${res.status}`)
  _config = await res.json()
}

export function getRuntimeValue(key: string): string | undefined {
  return _config?.[key]
}
